import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
import { CvpMenu } from "../../../generic-components/menu/CvpMenu";
import { device } from "../../../constants/mediaQueries";
import { withWSErrorContainer } from "../../../error/withWSErrorContainer";
import { completeMenuItem } from "../MenuItems/completeMenuItem";
import { useNavItems } from "../MenuItems/useNavItems";

export const SideNavMenu = withWSErrorContainer(
  observer(() => {
    const navItems = useNavItems().navItems;

    return (
      <StyledSideNavMenu
        className="cvp-side-nav"
        model={navItems.map((item) => completeMenuItem(item))}
      />
    );
  })
);

const StyledSideNavMenu = styled(CvpMenu)`
  &&.cvp-side-nav {
    padding-top: 8rem;
    width: 100%;
    border: none;
    background: var(--surface-a);

    .p-menuitem-link {
      display: flex;
      flex-direction: column;
      row-gap: 0.5rem;
      padding: 0.75rem 0;

      .p-menuitem-icon {
        width: 2.4rem;
        height: 2.4rem;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        background: var(--primary-50-relative);
        border-radius: 50%;
        color: var(--surface-600);
        margin-right: 0;
      }
      .p-menuitem-text {
        font-size: 0.9rem;
        font-weight: 500;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 100%;
      }

      @media ${device.xl} {
        display: flex;
        flex-direction: row;
        padding: 0.9rem 1.1rem;

        .p-menuitem-text,
        .p-menuitem-icon {
          font-size: 1rem;
        }

        .p-menuitem-icon {
          width: 2.75rem;
          height: 2.75rem;
          margin-right: 0.5rem;
        }
      }
    }
  }
`;
